// From https://stackoverflow.com/questions/54155510/how-can-i-invert-a-geojson-polygon
// and https://stackoverflow.com/questions/18082192/leaflet-inverse-reverse-polygon-style

export default [
  // [0, 90], [180, 90], [180, -90], [0, -90], [-180, -90], [-180, 0], [-180, 90], [0, 90],
  [-86, -180], [86, -180], [86, 180], [-86, 180],
];
